import React from 'react';

import { asField } from 'informed';
import { get } from 'lodash-es';

const HiddenField = asField(({ value, fieldApi, ...props }) => {
  const { setValue, setTouched } = fieldApi;
  const { onChange, onBlur, initialValue, forwardedRef, ...rest } = props;

  const handleChange = event => {
    const newValue = get(event, 'target.value');
    if (setValue) setValue(newValue);

    if (onChange) {
      onChange(newValue);
    }
  };
  const handleBlur = event => {
    const newValue = get(event, 'target.value');
    setTouched(true);

    if (onBlur) {
      onBlur(newValue);
    }
  };

  return (
    <input
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
      className="HiddenField"
      ref={forwardedRef}
      value={value || initialValue}
      onChange={handleChange}
      onBlur={handleBlur}
      type="hidden"
    />
  );
});

export default HiddenField;
